import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { orderService } from 'services/order.service'
import { reportService } from 'services/report.service'

import { routes } from 'utils/routes'
import { _object } from 'utils/interfaces'
import { dateFormat, formatPrice, generateDayWiseData, generateMonthWiseData } from 'utils'

import DayWiseOrdersChart from 'components/day-wise-orders-chart'

import StateOrdersPieChart from 'components/state-wise-orders-cart'
import MonthWiseOrdersChart from 'components/month-wise-order-cart'

import { Eye } from 'assets/icons'
import { productService } from 'services'

const Dashboard = () => {
  const [resenttOrders, setResentOrders] = useState<_object>({})
  const [staticsData, setStaticsData] = useState<_object>({})
  const [DayWiseData, setDayWiseData] = useState<_object>({})
  const [MonthWiseData, setMonthWiseData] = useState<_object>({})
  const [StateWiseData, setStateWiseData] = useState<_object>({})
  const [BestSeller, setBestSeller] = useState<_object>({})
  const [SlowMoving, setSlowMoving] = useState<_object>({})

  useEffect(() => {
    orderService.getOrders({ per_page: 10 }).then((results: _object) => {
      setResentOrders(results)
    })

    reportService.getStatics().then((results: _object) => {
      setStaticsData(results?.data)
    })

    productService
      .getProducts({
        page: 1,
        per_page: 4,
        sort: '-best_seller'
      })
      .then((results: _object) => {
        setBestSeller(results)
      })

    productService
      .getProducts({
        page: 1,
        per_page: 4,
        sort: 'best_seller'
      })
      .then((results: _object) => {
        setSlowMoving(results)
      })
  }, [])

  useEffect(() => {
    const today = new Date()
    const end_date = today.toISOString().split('T')[0]

    const pastDate = new Date()
    pastDate.setDate(today.getDate() - 30)
    const start_date = pastDate.toISOString().split('T')[0]

    reportService.getDayWiseOrders({ start_date, end_date }).then((results: _object) => {
      setDayWiseData(generateDayWiseData(results, start_date, end_date))
    })
  }, [])
  useEffect(() => {
    const today = new Date()
    const end_date = today.toISOString().split('T')[0]

    const pastYear = new Date()
    pastYear.setFullYear(today.getFullYear() - 1)
    const start_date = pastYear.toISOString().split('T')[0]

    reportService.getMonthWiseOrders({ start_date, end_date }).then((results: _object) => {
      if (results?.error === false) {
        setMonthWiseData(generateMonthWiseData(results, start_date, end_date))
      }
    })
  }, [])

  useEffect(() => {
    const today = new Date()
    const end_date = today.toISOString().split('T')[0]

    const pastYear = new Date()
    pastYear.setFullYear(today.getFullYear() - 1)
    const start_date = pastYear.toISOString().split('T')[0]

    reportService.getStateWiseOrders({ start_date, end_date }).then((results: _object) => {
      if (results?.error === false) {
        setStateWiseData(results?.data)
      }
    })
  }, [])

  return (
    <>
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">Dashboard</h1>
      </div>

      <div className="mb-6 grid grid-cols-1 gap-8 md:grid-cols-4">
        <div className="flex h-[160px] flex-col items-center justify-between rounded-lg bg-sky-500 text-center text-white shadow">
          <div className="mt-[30px]">
            <h4 className="mb-2 text-3xl font-bold text-white">{staticsData?.customers_count}</h4>
            <p className="text-white">All Customers</p>
          </div>

          <div className="flex w-full justify-center rounded-b-lg bg-sky-400">
            <Link
              to="https://app.myob.com/#/au/d9c059b9-0fdf-4310-ac2f-6f8704d39628/contact"
              className="flex gap-2 py-2 text-center text-sm font-semibold text-white/80"
              target="blank"
            >
              More info
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="20"
                height="20"
                x="0"
                y="0"
                viewBox="0 0 128 128"
                xmlSpace="preserve"
              >
                <g>
                  <path
                    d="M64 0C28.711 0 0 28.711 0 64s28.711 64 64 64 64-28.711 64-64S99.289 0 64 0zm0 120C33.121 120 8 94.879 8 64S33.121 8 64 8s56 25.121 56 56-25.121 56-56 56zm26.828-58.828a3.997 3.997 0 0 1 0 5.656l-20 20C70.047 87.609 69.023 88 68 88s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656L78.344 68H40c-2.209 0-4-1.789-4-4s1.791-4 4-4h38.344L65.172 46.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0z"
                    fill="#ffffff"
                    opacity="1"
                    data-original="#000000"
                  ></path>
                </g>
              </svg>
            </Link>
          </div>
        </div>

        <div className="flex h-[160px] flex-col items-center justify-between rounded-lg bg-green-500 text-center text-white shadow">
          <div className="mt-[30px]">
            <h4 className="mb-2 text-3xl font-bold text-white">{staticsData?.products_count}</h4>
            <p className="text-white">Total Products</p>
          </div>

          <div className="flex w-full justify-center rounded-b-lg bg-green-400">
            <Link
              to={routes?.products}
              className="flex gap-2 py-2 text-center text-sm font-semibold text-white/80"
            >
              More info
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="20"
                height="20"
                x="0"
                y="0"
                viewBox="0 0 128 128"
                xmlSpace="preserve"
              >
                <g>
                  <path
                    d="M64 0C28.711 0 0 28.711 0 64s28.711 64 64 64 64-28.711 64-64S99.289 0 64 0zm0 120C33.121 120 8 94.879 8 64S33.121 8 64 8s56 25.121 56 56-25.121 56-56 56zm26.828-58.828a3.997 3.997 0 0 1 0 5.656l-20 20C70.047 87.609 69.023 88 68 88s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656L78.344 68H40c-2.209 0-4-1.789-4-4s1.791-4 4-4h38.344L65.172 46.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0z"
                    fill="#ffffff"
                    opacity="1"
                    data-original="#000000"
                  ></path>
                </g>
              </svg>
            </Link>
          </div>
        </div>

        <div className="flex h-[160px] flex-col items-center justify-between rounded-lg bg-blue-500 text-center text-white shadow">
          <div className="mt-[30px]">
            <h4 className="mb-2 text-3xl font-bold text-white">{staticsData?.total_orders}</h4>
            <p className="text-white">⁠Total Orders</p>
          </div>

          <div className="flex w-full justify-center rounded-b-lg bg-blue-400">
            <Link
              to={routes?.orders}
              className="flex gap-2 py-2 text-center text-sm font-semibold text-white/80"
            >
              More info
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="20"
                height="20"
                x="0"
                y="0"
                viewBox="0 0 128 128"
                xmlSpace="preserve"
              >
                <g>
                  <path
                    d="M64 0C28.711 0 0 28.711 0 64s28.711 64 64 64 64-28.711 64-64S99.289 0 64 0zm0 120C33.121 120 8 94.879 8 64S33.121 8 64 8s56 25.121 56 56-25.121 56-56 56zm26.828-58.828a3.997 3.997 0 0 1 0 5.656l-20 20C70.047 87.609 69.023 88 68 88s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656L78.344 68H40c-2.209 0-4-1.789-4-4s1.791-4 4-4h38.344L65.172 46.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0z"
                    fill="#ffffff"
                    opacity="1"
                    data-original="#000000"
                  ></path>
                </g>
              </svg>
            </Link>
          </div>
        </div>

        <div className="flex h-[160px] flex-col items-center justify-between rounded-lg bg-red-500 text-center text-white shadow">
          <div className="mt-[30px]">
            <h4 className="mb-2 text-3xl font-bold text-white">
              {formatPrice(staticsData?.total_order_amount)}
            </h4>
            <p className="text-white">Total Order Amount</p>
          </div>
        </div>
      </div>

      <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow">
        <div className="mb-4 w-full rounded-t-xl border-b border-gray-300 bg-gray-100 px-4 py-3">
          <h2 className="text-xl font-bold">Statistics Order 30 Days</h2>
        </div>
        {DayWiseData?.length > 0 && <DayWiseOrdersChart finalData={DayWiseData} />}
      </div>

      <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow">
          <div className="w-full rounded-t-xl border-b border-gray-300 bg-gray-100 px-4 py-3">
            <h2 className="text-xl font-bold">Statistics Order By States</h2>
          </div>

          <div className="">
            {StateWiseData?.length > 0 && <StateOrdersPieChart finalData={StateWiseData} />}
          </div>
        </div>
        <div className="col-span-2 mb-6 rounded-lg border border-gray-200 bg-white shadow">
          <div className="mb-4 w-full rounded-t-xl border-b border-gray-300 bg-gray-100 px-4 py-3">
            <h2 className="text-xl font-bold">Statistics Order 12 Months</h2>
          </div>

          <div className="">
            {/* <img src={Statistics} alt="Statistics" className="h-auto w-full rounded" /> */}
            {MonthWiseData?.length > 0 && <MonthWiseOrdersChart finalData={MonthWiseData} />}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow lg:col-span-2">
          <div className="mb-4 flex w-full items-center justify-between rounded-t-lg border-b border-gray-300 bg-gray-100 px-4 py-3">
            <h4 className="text-lg font-semibold">Latest Orders</h4>
            <Link to={routes?.orders} className="text-sm underline">
              View All
            </Link>
          </div>
          <table className="min-w-full">
            <thead className="">
              <tr className="text-left text-base font-medium text-gray-900">
                <th className="w-[36px] p-2 ps-3 font-semibold">#</th>
                <th className="w-[115px] p-2 font-semibold whitespace-nowrap">Order ID</th>
                <th className="w-[168px] p-2 font-semibold">Customer</th>
                <th className="p-2 font-semibold">Shipping Address</th>

                <th className="p-2 font-semibold">Date</th>
                <th className="p-2 font-semibold">Total</th>
                <th className="p-2 pl-3 text-center font-semibold">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 p-0 text-sm">
              {resenttOrders?.items?.map((item: _object, i: number) => {
                return (
                  <tr className="border-b px-0 hover:bg-gray-50" key={i}>
                    <td className="p-2 text-sm">{i + 1}</td>
                    <td className="p-2 text-sm">{item?.order_number}</td>
                    <td className="p-2 text-sm">
                      {item?.user?.first_name} {item?.user?.last_name}
                    </td>
                    <td className="p-2 text-sm">
                      {[
                        item?.shipping?.address1,
                        item?.shipping?.address2,
                        item?.shipping?.city,
                        item?.shipping?.country,
                        item?.shipping?.state,
                        `phone number ${item?.shipping?.postcode}`,
                        item?.shipping?.phone
                      ]
                        .filter(Boolean)
                        .join(', ')}
                    </td>
                    <td className="w-[100px] p-0 text-sm">{dateFormat(item?.created_at)}</td>
                    <td className="p-2 text-sm">{formatPrice(item?.total)}</td>
                    <td className="p-2 text-center text-sm">
                      <Link
                        to={`${routes.orders}/${item.id}`}
                        className="inline-block"
                        title="View Details"
                      >
                        <img src={Eye} alt="Eye" height={20} width={20} />
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div>
          <div className="rounded-xl bg-white shadow">
            <div className="w-full rounded-t-lg border-b border-gray-300 bg-gray-100 px-4 py-3">
              <h4 className="text-lg font-semibold">Product By Sales</h4>
            </div>
            <div className="p-4">
              <p className="mb-4">
                <strong>Bestselling Products</strong>
              </p>
              {BestSeller?.items?.map((item: _object, i: number) => {
                return (
                  <div className="mb-4" key={i}>
                    <div className="flex justify-between text-sm font-medium">
                      <Link
                        to={`https://treasuresunlimited.vercel.app/products/${item.id}`}
                        target="blank"
                      >
                        <span>{item.title}</span>
                      </Link>
                      <span> {item.order_count}</span>
                    </div>
                    <div className="mt-1 h-3 w-full rounded-full bg-gray-200">
                      <div className="h-3 w-full rounded-full bg-green-600"></div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="p-4">
              <h6 className="mb-4 text-lg">⁠Slow-moving products</h6>
              {SlowMoving?.items?.map((item: _object, i: number) => {
                return (
                  <div className="mb-4" key={i}>
                    <div className="flex justify-between text-sm font-medium">
                      <Link
                        to={`https://treasuresunlimited.vercel.app/products/${item.id}`}
                        target="blank"
                      >
                        {' '}
                        <span>{item.title}</span>
                      </Link>
                      <span>{item.order_count}</span>
                    </div>
                    <div className="mt-1 h-3 w-full rounded-full bg-gray-200">
                      <div className="h-3 w-full rounded-full bg-green-600"></div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
